import { ScrollText } from 'lucide-react';

import { EmptyState, ngayGioNgan } from '../../../ui/index.js';
import { useNhatKy } from '../api.js';

function ngayGioVn(iso: string): string {
  return ngayGioNgan(iso);
}

/** Nhật ký xử lý: 20 dòng gần nhất, hoặc của riêng một sự cố. */
export function KhungNhatKy({ issueId }: { issueId?: string }) {
  const nhatKy = useNhatKy(issueId);
  const dong = nhatKy.data ?? [];

  return (
    <section aria-labelledby="nhat-ky-tieu-de" className="rounded-the border border-vien bg-be-mat">
      <h2
        id="nhat-ky-tieu-de"
        className="border-b border-vien px-6 py-4 text-tieu-de-khoi font-semibold text-chu"
      >
        Nhật ký xử lý
      </h2>

      {nhatKy.isPending && <p className="px-6 py-5 text-co-ban text-chu-phu">Đang tải nhật ký…</p>}

      {nhatKy.error && (
        <p role="alert" className="px-6 py-5 text-co-ban text-bad-chu">
          {nhatKy.error.message}
        </p>
      )}

      {!nhatKy.isPending && !nhatKy.error && dong.length === 0 && (
        <EmptyState
          icon={ScrollText}
          title="Chưa có ghi chép nào"
          description="Mỗi lần bấm hành động gợi ý, hệ thống tự ghi một dòng vào đây."
        />
      )}

      {dong.length > 0 && (
        <ol className="divide-y divide-vien">
          {dong.map((l) => (
            <li key={l.id} className="px-6 py-4">
              <p className="text-co-ban text-chu">{l.text}</p>
              <p className="mt-1 text-phu text-chu-mo">
                {l.userName ?? 'Hệ thống'} ·{' '}
                <span className="so-lieu">{ngayGioVn(l.createdAt)}</span>
              </p>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
